import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../../shared/js';

import styles from './quote-loading.module.scss';

const QuoteLoading = ({ loading, ...props }) => {
  const { formatMessage } = useIntl();
  const [hide, setHide] = useState(false);
  useEffect(() => {
    loading && setHide(false);
  }, [loading]);

  const handleAnimationEnd = () => {
    if (loading) return;
    setHide(true);
  };
  return (
    <div
      className={cn(
        styles.spinner,
        props.className,
        { [styles.loading]: loading, [styles.hide]: hide },
        applyClasses(props, styles)
      )}
      {...applyProps(props)}
      onAnimationEnd={handleAnimationEnd}
    >
      <div
        className={styles.cssSpinner}
        aria-label={formatMessage({
          id: 'accessibility.loading',
          defaultMessage: 'loading',
        })}
      />
    </div>
  );
};

QuoteLoading.propTypes = {
  /** Whether or not the loader is active */
  loading: PropTypes.bool,
  /** A class name forwarded to the parent overlay component */
  className: PropTypes.string,
  /** A style object forwarded to the parent overlay component */
  style: PropTypes.string,
};

QuoteLoading.defaultProps = {
  loading: undefined,
  className: undefined,
  style: undefined,
};

export default QuoteLoading;
